(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSupportedWidgetTypes', {
		bindings: {
			value: '=?',
			label: '@',
			disabled: '=ngDisabled',
		},
		controller: MxSupportedWidgetTypesCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-supported-widget-types/mx-supported-widget-types.html',
	});

	MxSupportedWidgetTypesCtrl.$inject = ['$scope', 'mx.internationalization'];

	function MxSupportedWidgetTypesCtrl($scope, $i18n) {
		var vm = this;
		var localChanged = false;

		vm.i18n = $i18n.get('solutionBuilderAgent.widgetTypes');
		vm.types = [];
		vm.$onInit = function () {
			_.forIn(mx.SolutionBuilderAgent.ContentWidgetType, function (widgetType, widgetName) {
				vm.types.push({
					value: widgetType + 1,
					flag: widgetType > 0 ? Math.pow(2, widgetType) : 1,
					name: vm.i18n[widgetName] || widgetName,
				});
			});
			vm.supportedTypes = {};
			processTypes(vm.value);
		};

		$scope.$watch('vm.value', function (newValue) {
			if (localChanged) {
				localChanged = false;
			} else {
				processTypes(newValue);
			}
		});

		$scope.$watch(
			'vm.supportedTypes',
			function (newValue) {
				localChanged = true;
				var flTypes = 0;

				_.forIn(newValue, function (value, key) {
					if (value) {
						flTypes |= vm.types[Number(key) - 1].flag;
					}
				});
				vm.value = flTypes;
			},
			true
		);

		function processTypes(value) {
			vm.supportedTypes = {};
			vm.types.forEach(function (item) {
				if (value & item.flag) {
					vm.supportedTypes[item.value] = true;
				}
			});
		}
	}
})();
